module.exports = __webpack_public_path__ + "img/img-bioprotection.a9ab11ec.svg";